import { Link } from "react-router-dom";
import Layout from "../../../components/global/layout";
import "./profile.scss";
import methodModel from "../../../methods/methods";
import { useSelector } from "react-redux";
import { MdOutlineMailOutline } from "react-icons/md";
import { BiUser } from "react-icons/bi";
import { HiOutlinePhone } from "react-icons/hi";
import { FiEdit3 } from "react-icons/fi";
import { FaSms } from "react-icons/fa";

const Profile = () => {
  const user = useSelector((state: any) => state.user);

  return (
    <Layout>
      <div className="wrapper_section py-6 lg:py-16">
        <div className="flex items-center justify-center">
        <div className="w-4/12 mx-auto">
            <div className="p-6 shadow overflow-hidden rounded-lg bg-white">
              <div className="flex flex-col gap-4 mb-6">
                <div className="">
                  <img src={methodModel.userImg(user?.image)} className="h-36 w-36 rounded-full object-cover mx-auto" />
                </div>
                <div className="flex flex-col gap-y-4">
                  <div className="flex items-center justify-between shadow-sm p-2">
                    <div>
                      <label className="text-gray-800 font-semibold text-md">Full Name</label>
                      <p className="text-sm text-gray-700 flex items-center gap-2 capitalize">{user?.fullName}</p>
                    </div>
                    <p className="bg-primary rounded-full h-10 w-10 flex items-center justify-center text-white"><BiUser className="text-xl" /></p>
                  </div>
                  <div className="flex items-center justify-between shadow-sm p-2">
                    <div>
                      <label className="text-gray-800 font-semibold text-md">Email</label>
                      <p className="text-sm text-gray-700 flex items-center gap-2">{user?.email}</p>
                    </div>
                    <p className="bg-primary rounded-full h-10 w-10 flex items-center justify-center text-white"><MdOutlineMailOutline className="text-xl" /></p>
                  </div>
                  <div className="flex items-center justify-between shadow-sm p-2">
                    <div>
                      <label className="text-gray-800 font-semibold text-md">Phone Number</label>
                      <p className="text-sm text-gray-700 flex items-center gap-2">{!user?.mobileNo ? '--' : `+${user?.dialCode + user?.mobileNo}`}</p>
                    </div>
                    <p className="bg-primary rounded-full h-10 w-10 flex items-center justify-center text-white"><HiOutlinePhone className="text-xl" /></p>
                  </div>
                  <div className="flex items-center justify-between shadow-sm p-2">
                    <div>
                      <label className="text-gray-800 font-semibold text-md">Allow the SMS updates</label>
                      <p className="text-sm text-gray-700 flex items-center gap-2">{user?.isTwillio === true ? "Yes" : "No"}</p>
                    </div>
                    <p className="bg-primary rounded-full h-10 w-10 flex items-center justify-center text-white"><FaSms className="text-xl" /></p>
                  </div>
                </div>
              </div>
              <Link
                to="/profile/edit"
                className="px-2 lg:!px-4 text-sm font-normal bg-primary text-white h-10 flex items-center justify-center gap-2 rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
              >
              <FiEdit3 />
                Edit Profile
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;